module.exports = __webpack_public_path__ + "img/CRC1_CD8Tex.2b93b811.png";